export default {
    menuOptionsList: $("#option-list"),
    modal: $("#pullFocusModal"),
    participantsList: $("#pullFocusParticipant"),
    pullFocusTo: $("#pullFocusTo"),
    errorMessage: $("#pullFocusErrorMessage"),
    masterVolumeValue: $("#pull-focus-volume-slider"),
    muteAllCheckBox: $("#pull-focus-mute-all-checkbox"),
    // lockMasterVolumeOnStage: $('#lock-master-volume-on-stage'),
    minimizePullFocus: $('#minimize-pull-focus'),
    pullFocusTimer: $('#pullFocusTimer'),
    focusedIcon: `<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px">
    <path fill="#032836" d="M12,2c-4.2,0-8,3.22-8,8.2c0,3.18,2.45,6.92,7.34,11.22c0.36,0.32,0.97,0.32,1.33,0C17.55,17.12,20,13.38,20,10.2 C20,5.22,16.2,2,12,2z M7.69,12.49C8.88,11.56,10.37,11,12,11s3.12,0.56,4.31,1.49C15.45,13.98,13.85,15,12,15 S8.55,13.98,7.69,12.49z M12,6c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2s-2-0.9-2-2C10,6.9,10.9,6,12,6z"/>
</svg>`,
    focusedIconNotification: `<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px">
    <path fill="#e0e4e5" d="M12,2c-4.2,0-8,3.22-8,8.2c0,3.18,2.45,6.92,7.34,11.22c0.36,0.32,0.97,0.32,1.33,0C17.55,17.12,20,13.38,20,10.2 C20,5.22,16.2,2,12,2z M7.69,12.49C8.88,11.56,10.37,11,12,11s3.12,0.56,4.31,1.49C15.45,13.98,13.85,15,12,15 S8.55,13.98,7.69,12.49z M12,6c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2s-2-0.9-2-2C10,6.9,10.9,6,12,6z"/>
</svg>`
};